var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_content"},[_c('div',{staticClass:"center"},[_c('img',{staticClass:"tip_img",attrs:{"src":_vm.curItem.img,"alt":_vm.curItem.alt}}),_c('div',[_vm._v(_vm._s(_vm.curItem.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }